export default "__VITE_ASSET__BEt31Ytr__"